import React from "react";

import {
  IconBilling,
  IconBroadband,
  IconCreditCard,
  IconEnergy,
  IconLiveChat,
  IconLocalOffer,
  IconMyAccount,
  IconReportProblemOutlined,
} from "@origin-digital/ods-icons";

import { ICategory } from "../../../../shared/interface/category";
import { IQuickLink } from "./QuickLink";

export const sortLinksByOrder = (links: IQuickLink[]) => {
  if (!!links && links.length > 1) {
    links.sort((linkOne, linkTwo) => linkOne.order - linkTwo.order);
  }
};

const UNKNOWN_CATEGORY = "UNKNOWN_CATEGORY";

export const slugToIcon: Record<string, JSX.Element> = {
  "internet-products-and-services": <IconBroadband />,
  "billing-and-payments": <IconCreditCard />,
  "outages-and-emergencies": <IconReportProblemOutlined />,
  "account-management": <IconMyAccount />,
  "financial-assistance-and-payment-plans": <IconBilling />,
  "energy-products-and-services": <IconEnergy />,
  "earn-rewards": <IconLocalOffer />,
  UNKNOWN_CATEGORY: <IconLiveChat />,
};

export const categoryIcon = (category: ICategory): React.ReactNode => {
  const categoryKey =
    category.uri in slugToIcon ? category.uri : UNKNOWN_CATEGORY;

  return slugToIcon[categoryKey];
};
